import * as React from 'react';

import { Button, HStack, Header, Icon, VStack } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { getQuestCheckConnectionText, getQuestLoadErrorText } from '../custom-text';

const Wrapper = VStack.withConfig({
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  space: '$6',
  padding: '$4',
});

const ReloadButton = Button.withConfig({
  variant: 'outline',
  borderColor: getDesignToken('border-color-error'),
  _text: {
    variant: 'copyTwo',
    fontSize: 'sm',
    color: getDesignToken('text-error'),
  },
});

export const QuestDetailError = ({ refetch }: { refetch: () => void }) => {
  const errorHeaderMessage = getQuestLoadErrorText();

  useLogUserErrorMessage({
    message: errorHeaderMessage,
    severity: LogUserErrorSeverity.GeneralError,
    context: {
      moreInfo: 'quest-detail-error.tsx',
    },
  });

  return (
    <Wrapper>
      <VStack>
        <Header textAlign="center">{errorHeaderMessage}</Header>
        <Typography textAlign="center">{getQuestCheckConnectionText()}</Typography>
      </VStack>
      <HStack flexShrink={1}>
        <ReloadButton
          leftIcon={
            <Icon variant="refresh" size="sm" color={getDesignToken('border-color-error')} />
          }
          onPress={refetch}
        >
          {t('tryAgain')}
        </ReloadButton>
      </HStack>
    </Wrapper>
  );
};
